<template>
  <div class="order-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="订单号">
          <el-input v-model="filterForm.order_dh" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item label="接单状态">
          <el-select v-model="filterForm.status_jie" placeholder="全部" clearable>
            <el-option label="可接单" value="可接单" />
            <el-option label="配货中" value="配货中" />
            <el-option label="已完成" value="已完成" />
            <el-option label="已作废" value="已作废" />
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="filterForm.status" placeholder="全部" clearable>
            <el-option label="待发货" value="待发货" />
            <el-option label="已发货" value="已发货" />
            <el-option label="退货中" value="退货中" />
            <el-option label="已处理" value="已处理" />
          </el-select>
        </el-form-item>
        <el-form-item label="付款状态">
          <el-select v-model="filterForm.pay_type" placeholder="全部" clearable>
            <el-option label="待付款" value="待付款" />
            <el-option label="已支付" value="已支付" />
            <el-option label="已退款" value="已退款" />
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 订单列表表格 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="orderList"
        height="56vh"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="order_dh" label="订单号" min-width="220" show-overflow-tooltip />
        <el-table-column prop="sh_name" label="店铺名称" min-width="150" />
        <el-table-column prop="sh_img" label="店铺图片" width="80">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.sh_img"
              :preview-src-list="[scope.row.sh_img]"
              fit="cover"
              style="width: 40px; height: 40px; border-radius: 4px;"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="status_jie" label="接单状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getJieStatusType(scope.row.status_jie)" size="small">
              {{ scope.row.status_jie }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getOrderStatusType(scope.row.status)" size="small">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pay_type" label="付款状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getPayTypeType(scope.row.pay_type)" size="small">
              {{ scope.row.pay_type }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="quhuo" label="收货状态" width="90" />
        <el-table-column prop="comlist_f1" label="订单金额(元)" width="110" >
          <template slot-scope="scope">
             <span class="money">¥{{ parseFloat(scope.row.comlist_f1).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="comlist_v6" label="支付方式" width="100" />
        <el-table-column prop="comlist3" label="下单时间" width="160" />
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleViewDetail(scope.row)">
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 订单详情弹窗 -->
    <el-dialog title="订单详情" :visible.sync="dialogVisible" width="60%">
      <el-descriptions :column="2" border v-if="currentOrder">
        <el-descriptions-item label="订单号">{{ currentOrder.order_dh }}</el-descriptions-item>
        <el-descriptions-item label="店铺名称">{{ currentOrder.sh_name }}</el-descriptions-item>
        <el-descriptions-item label="接单状态">{{ currentOrder.status_jie }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">{{ currentOrder.status }}</el-descriptions-item>
        <el-descriptions-item label="付款状态">{{ currentOrder.pay_type }}</el-descriptions-item>
        <el-descriptions-item label="收货状态">{{ currentOrder.quhuo }}</el-descriptions-item>
        <el-descriptions-item label="订单金额"> <span class="money">¥{{ parseFloat(currentOrder.comlist_f1).toFixed(2) }}</span>  </el-descriptions-item>
        <el-descriptions-item label="优惠金额"> <span class="money"></span></el-descriptions-item>
        <el-descriptions-item label="支付方式">{{ currentOrder.comlist_v6 }} ({{ currentOrder.comlist_v6_1 }})</el-descriptions-item>
        <el-descriptions-item label="下单时间">{{ currentOrder.comlist3 }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{ currentOrder.comlist_v2 }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ currentOrder.comlist_v3 }}</el-descriptions-item>
        <el-descriptions-item label="提货方式">{{ currentOrder.comlist_v1 }}</el-descriptions-item>
        <el-descriptions-item label="期望提货日">{{ currentOrder.comlist_v5 }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import Cookie from 'js-cookie'

const token = Cookie.get('token')
const ddRequest = axios.create({
  withCredentials: true,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    comlistToken: token
  }
})

export default {
  name: 'OrderList',
  data () {
    return {
      loading: false,
      orderList: [],
      filterForm: {
        order_dh: '',
        status_jie: '',
        status: '',
        pay_type: '',
        start_time: '',
        end_time: ''
      },
      dateRange: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      dialogVisible: false,
      currentOrder: null
    }
  },
  mounted () {
    this.getOrderList()
  },
  methods: {
    // 获取订单列表
    async getOrderList () {
      this.loading = true
      try {
        // 构建请求参数
        const params = {
          page: this.currentPage,
          page_size: this.pageSize,
          ...this.filterForm
        }
        // 移除空值参数
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })

        const response = await ddRequest.post('https://caixiao.lianglianyn.com/common/merchant.php?a=getOrders', { ...params })

        if (response.data.code === '0') {
          this.orderList = response.data.res || []
          this.pages = response.data.pages || 0
          // 计算总条数（用于分页显示，根据pages和pageSize估算）
          this.total = this.pages * this.pageSize
        } else if (response.data.code === 1001) {
          this.$message.error('请先登录')
          this.orderList = []
          this.total = 0
        } else {
          this.$message.error(response.data.msg || '获取订单列表失败')
          this.orderList = []
          this.total = 0
        }
      } catch (error) {
        console.error('请求订单列表出错:', error)
        this.$message.error('网络错误，请稍后重试')
        this.orderList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch () {
      // 处理日期范围
      if (this.dateRange && this.dateRange.length === 2) {
        this.filterForm.start_time = this.dateRange[0]
        this.filterForm.end_time = this.dateRange[1]
      } else {
        this.filterForm.start_time = ''
        this.filterForm.end_time = ''
      }
      this.currentPage = 1
      this.getOrderList()
    },

    // 重置筛选条件
    handleReset () {
      this.filterForm = {
        order_dh: '',
        status_jie: '',
        status: '',
        pay_type: '',
        start_time: '',
        end_time: ''
      }
      this.dateRange = []
      this.currentPage = 1
      this.getOrderList()
    },

    // 分页-每页数量变化
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getOrderList()
    },

    // 分页-当前页变化
    handleCurrentChange (val) {
      this.currentPage = val
      this.getOrderList()
    },

    // 查看订单详情
    handleViewDetail (row) {
      this.currentOrder = row
      this.dialogVisible = true
    },

    // 接单状态样式
    getJieStatusType (status) {
      const map = {
        可接单: 'success',
        配货中: 'warning',
        已完成: 'info',
        已作废: 'danger'
      }
      return map[status] || 'info'
    },

    // 订单状态样式
    getOrderStatusType (status) {
      const map = {
        待发货: 'warning',
        已发货: 'success',
        退货中: 'danger',
        已处理: 'info'
      }
      return map[status] || 'info'
    },

    // 付款状态样式
    getPayTypeType (payType) {
      const map = {
        待付款: 'danger',
        已支付: 'success',
        已退款: 'warning'
      }
      return map[payType] || 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
 .money{
 color: #ee530c;
 }
.order-container {
  padding:  0 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    // margin-bottom: 20px;

    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-card {
    .pagination {
      margin-top: 20px;
      text-align: right;
    }

    .image-slot {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      background-color: #f5f7fa;
      color: #909399;
      font-size: 20px;
    }
  }
}
</style>
